<template>
    <div class="sdr-box contact-box">
        <h4>{{ needhelp[getCurrentLocale] }}</h4>
        <p>{{ sideboxhelptext[getCurrentLocale] }}</p>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-message"></i> {{ contact[getCurrentLocale]}}</span>
            <br>
            <a href="mailto:slr-vc-service@schauinsland-reisen.de" class="contact-email">slr-vc-service@schauinsland-reisen.de</a>
        </address>
        <br>
        <p>{{ pastsideboxhelptext[getCurrentLocale] }}</p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                contact: {
                    en: 'Contact',
                    de: 'Kontakt',
                },
                needhelp: {
                    en: 'Do you need help or support?',
                    de: 'Benötigen Sie Hilfe oder Unterstützung?',
                },
                sideboxhelptext: {
                    de: 'Bitte senden Sie Ihre Anfrage an:',
                    en: 'Please send your request to:',
                },
                pastsideboxhelptext: {
                    de: 'Reservierungen sind bis 96 Stunden vor Abflug möglich.',
                    en: 'Reservation is available until 96 hours before departure.',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>


<style>
    .contact-details .contact-email {
        padding: 0 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/sidebar/ContactBox.vue